// extracted by mini-css-extract-plugin
export default {"socialStars":"RatingStars_socialStars__yVuvh","socialStars__item":"RatingStars_socialStars__item__f2L2e","starIcon":"RatingStars_starIcon__8YOQ1"};